<template>
  <component
    :is="tag"
    class="button--icon"
    :class="classes"
    :href="href"
    v-bind="$props"
    @click="(event) => $emit('click', event)"
  >
    <i :class="'icon icon-' + icon" />
    <slot />
  </component>
</template>

<script>
import ButtonComponent from "@/components/Button.vue";
export default {
  name: "IconButton",
  extends: ButtonComponent,
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  emits: ["click"],
  computed: {
    classes() {
      return {
        "button--icon--has-text": Boolean(this.$slots.default),
        easysize_button: this.easysize,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.button--icon {
  background: none;
  outline: none;
  border: none;
  padding: 15px;
  display: inline-block;
  text-decoration: none;

  &--has-text {
    .icon {
      margin-right: 10px;
    }
  }
}
</style>
